import type { ConfigType } from '@plone/registry';
import loadable from '@loadable/component';

export default function install(config: ConfigType) {
  // TODO Workaround für fehlende Registrierung in volto-form-block????
  config.settings.loadables.reactDnd = loadable.lib(() => import('react-dnd'));
  config.settings.loadables.reactDndHtml5Backend = loadable.lib(
    () => import('react-dnd-html5-backend'),
  );

  // Language settings
  config.settings.defaultLanguage = 'de';
  // Additional language settings for Volto 19 and above, add as many supported languages as needed
  // Languages not added to supportedLanguages will not be included in the build
  // config.settings.supportedLanguages = ['de'];

  config.settings.DSGVOBanner = {
    ...(config.settings.DSGVOBanner as Record<string, unknown>),
    tracker: {
      type: 'matomo',
      urlBase: 'https://piwik.portknox.net/',
      id: 13,
    },
    modules: ['tracking'],
  };

  // Custom Colors for all Blocks
  const COLORS = [
    {
      style: {
        '--theme-color': '#fff', // Block Wrapper
        '--theme-high-contrast-color': '#edecf1', // Cards in Grid block
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': '#fce1d0',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#ababab',
      },
      name: 'apricot',
      label: 'Apricot',
    },
    {
      style: {
        '--theme-color': '#edecf1',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'grey',
      label: 'Grey',
    },
    {
      style: {
        '--theme-color': '#ac1e25',
        '--theme-high-contrast-color': '#323232',
        '--theme-foreground-color': '#fff',
        '--theme-low-contrast-foreground-color': '#323232',
      },
      name: 'red',
      label: 'Red',
    },
    {
      style: {
        '--theme-color': '#f9f3f0',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#ababab',
      },
      name: 'creme',
      label: 'Creme',
    },
  ];

  config.blocks.themes = COLORS;
  config.blocks.blocksConfig.gridBlock.themes = COLORS;

  return config;
}
